import { Reducer } from "redux";
import * as tagActions from "./tagActions";
import { VenueTag } from "../../model/VenueTag";
import produce from "immer";

export interface TagState {
  tags: {
    [organization: string]: VenueTag[];
  };
  isLoadingTags: {
    [organization: string]: boolean;
  };
}

const initialState: TagState = {
  tags: {},
  isLoadingTags: {},
};

type SupportedActions =
  | tagActions.GetTagsForOrganizationSuccessAction
  | tagActions.GetTagsForOrganizationAction
  | tagActions.GetTagsForOrganizationFailAction;

export const tagReducer: Reducer<TagState, SupportedActions> = (
  state = initialState,
  action
) => {
  return produce(state, (draftState) => {
    switch (action.type) {
      case tagActions.GET_TAGS_FOR_ORGANIZATION: {
        draftState.isLoadingTags[action.organization] = true;
        break;
      }
      case tagActions.GET_TAGS_FOR_ORGANIZATION_FAIL: {
        draftState.isLoadingTags[action.organization] = false;
        break;
      }
      case tagActions.GET_TAGS_FOR_ORGANIZATION_SUCCESS: {
        draftState.isLoadingTags[action.organization] = true;
        draftState.tags[action.organization] = action.tags;
        break;
      }
    }
  });
};
